import { z } from 'zod';

export const decimalString = z
  .string()
  .trim()
  .min(1, 'Required')
  .refine((value) => /^-?\d+(\.\d+)?$/.test(value), 'Must be a number')
  .refine((value) => Number.parseFloat(value) > 0, 'Must be greater than zero');

// react-hook-form initialises inputs with '' rather than undefined; the
// preprocessor converts empties to undefined so the optional()-wrapped
// schemas don't fire their inner min/format errors when the user has
// genuinely left the field blank.
export const emptyToUndefined = (value: unknown): unknown =>
  typeof value === 'string' && value.trim().length === 0 ? undefined : value;

export const optionalDecimal = z.preprocess(emptyToUndefined, decimalString.optional());

export const optionalText = (max: number) =>
  z.preprocess(emptyToUndefined, z.string().trim().max(max).optional());

export function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10);
}
